import React from "react";

const FacadeSolutions = () => {
  return (
    <section className="tc-service-details section-padding">
      {/* Hero Section */}
      <div className="page-hero">
  <div className="img position-relative">
    <img
      src="\home2\assets\img\services\FACDESOLUTION.jpg"
      alt="Facade Solutions"
      className="img-fluid w-100 radius-6"
    />

    {/* Desktop Overlay */}
    <div className="info-overlay desktop-only d-flex align-items-end">
      <div className="container pb-40">
        <h1
          className="text-white fw-600 fsz-50 wow fadeInUp slow"
          data-wow-delay="0.2s"
        >
          Facade Solutions
        </h1>
        <p
          className="text-white-50 mt-10 fsz-18 wow fadeInUp slow"
          data-wow-delay="0.3s"
        >
          Innovative, durable, and aesthetically refined facade systems that define
          modern architecture.
        </p>
      </div>
    </div>
  </div>

  {/* Mobile Text (below image) */}
  <div className="info-under mobile-only">
    <div className="container pt-3 pb-3">
      <h1 className="text-dark fw-600 fsz-28">Facade Solutions</h1>
      <p className="text-dark mt-2 fsz-15">
        Innovative, durable, and aesthetically refined facade systems that define
        modern architecture.
      </p>
    </div>
  </div>
</div>


      {/* Main Content */}
      <div className="container mt-80">
        <div className="row justify-content-between align-items-start">
          <div className="col-lg-12">
            <div className="main-content">
              

              {/* HPL Section */}
              <div className="solution-item mb-80">
                <h4
                  className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                  data-wow-delay="0.2s"
                >
                  1. HPL (High Pressure Laminate)
                </h4>
                <ul
                  className="dots-list fsz-18 color-666 wow fadeInUp slow"
                  data-wow-delay="0.2s"
                >
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    UV-resistant and weatherproof for long-lasting outdoor performance.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Offers wide design options — wood, stone, and solid color finishes.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Easy to clean and maintain, ideal for sustainable building exteriors.
                  </li>
                </ul>
              </div>

              {/* Zinc Composite Section */}
              <div className="solution-item mb-80">
                <h4
                  className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                  data-wow-delay="0.3s"
                >
                  2. Zinc Composite Panels
                </h4>
                <ul
                  className="dots-list fsz-18 color-666 wow fadeInUp slow"
                  data-wow-delay="0.3s"
                >
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Naturally self-healing surface that resists corrosion and scratches.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Provides a sleek metallic finish ideal for high-end architecture.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Excellent fire performance and long-term durability.
                  </li>
                </ul>
              </div>

              {/* ACP Section */}
              <div className="solution-item mb-80">
                <h4
                  className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                  data-wow-delay="0.4s"
                >
                  3. ACP (Aluminium Composite Panels)
                </h4>
                <ul
                  className="dots-list fsz-18 color-666 wow fadeInUp slow"
                  data-wow-delay="0.4s"
                >
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Lightweight, flexible, and suitable for both interior and exterior use.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Offers superior flatness and color consistency across panels.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Cost-effective facade solution for modern commercial spaces.
                  </li>
                </ul>
              </div>

              {/* Louver Section */}
              <div className="solution-item mb-80">
                <h4
                  className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                  data-wow-delay="0.5s"
                >
                  4. Louver Systems
                </h4>
                <ul
                  className="dots-list fsz-18 color-666 wow fadeInUp slow"
                  data-wow-delay="0.5s"
                >
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Enhances airflow and daylight while maintaining privacy and shade.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Can be fixed or operable, customized to meet building design needs.
                  </li>
                  <li className="d-flex my-3">
                    <span className="icon me-3">•</span>
                    Available in aluminum, glass, and wooden finishes for visual harmony.
                  </li>
                </ul>
              </div>

              {/* CTA */}
              <div
                className="cta-section mt-50 wow fadeInUp slow text-center"
                data-wow-delay="0.6s"
              >
                <a href="/contact" className="butn butn-md butn-orange1 radius-30">
                  <span>Contact Us for Custom Facade Solutions</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacadeSolutions;
